import { render } from "./UnitListComponent.vue?vue&type=template&id=1ec81281"
import script from "./UnitListComponent.vue?vue&type=script&lang=js"
export * from "./UnitListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Unit/UnitListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ec81281"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ec81281', __exports__)) {
    api.reload('1ec81281', __exports__)
  }
  
  module.hot.accept("./UnitListComponent.vue?vue&type=template&id=1ec81281", () => {
    api.rerender('1ec81281', render)
  })

}


export default __exports__